import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {fetchMSWLHR} from '/redux/action/client.action';
import {mswlData} from '/redux/selector/client.selector';
import {fromProps, withProps} from '/util/selector.util';

import ClientMWL from './ClientMWL';

interface StateProps {
  mswlData: {};
}

interface DispatchProps {
  fetchMSWLHR: (params: {clientId: string}) => void;
}

interface OwnProps {
  recordId: string;
}

interface MWLData {
  data: {
    medicalWeightLoss?: string;
  };
}

const withClientId = withProps({
  clientId: fromProps(get('recordId')),
});

export default connect<StateProps, DispatchProps, OwnProps>(
  createStructuredSelector({
    mswlData: withClientId(mswlData),
  }),
  dispatch => ({
    fetchMSWLHR: ({clientId}: {clientId: string}) =>
      dispatch(fetchMSWLHR({clientId})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,

      fetchMSWLHR: async (mwldata: MWLData, clientId: string) => {
        const {medicalWeightLoss} = mwldata.data || {};
        await Promise.resolve().then(() =>
          medicalWeightLoss
            ? dispatchProps.fetchMSWLHR({clientId})
            : Promise.resolve(),
        );
      },
    };
  },
)(ClientMWL);
